export type IReportingResult = Record<string, any>;

export interface IFilterSpecTarget {
  key: string;
  value: string;
}

interface IReportFilter {
  id: string;
  dimension: string;
  action: string;
  specTarget: IFilterSpecTarget[];
}

export type ReportConstraintOperator =
  | "gt"
  | "gte"
  | "lt"
  | "lte"
  | "eq"
  | "neq";

interface IReportConstraint {
  id: string;
  /** Projected column key, not the metric-picker key — see metricColumnName. */
  metric: string;
  operator: ReportConstraintOperator;
  value: number | "";
}

export interface IReport {
  _id: string | number | null;
  templateRevision?: number;
  name: string;
  description: string;
  createdBy: string;
  startDate: string | null;
  endDate: string | null;
  timeAggregation: string;
  preset: string;
  reportType: "pixel" | "advertiser";
  dimensions: Array<{ key: string; value: string }>;
  metrics: Array<{ eventType: string; label: string }>;
  customLabels: Array<{ key: string; value: string }>;
  filters: IReportFilter[];
  constraints: IReportConstraint[];
  timezone: string;
  idCampaign: string;
}

export const initialReportObj: IReport = {
  _id: null,
  name: "",
  description: "",
  createdBy: "",
  startDate: null,
  endDate: null,
  timeAggregation: "Sum",
  preset: "choose time preset",
  reportType: "pixel",
  dimensions: [],
  metrics: [],
  customLabels: [],
  filters: [],
  constraints: [],
  timezone: "UTC",
  idCampaign: "",
};

export type FormulaOperator = "+" | "-" | "*" | "/";

export type FormulaToken =
  | { t: "op"; v: FormulaOperator }
  | { t: "lparen" }
  | { t: "rparen" }
  | { t: "num"; v: number }
  | {
      t: "ref";
      kind: "metric" | "event" | "dimension" | "sum_event" | "matched_event";
      key: string;
    };

export interface ICalculatedMetricFormat {
  prefix?: string;
  suffix?: string;
  decimals: number;
}

export interface ICalculatedMetric {
  key: string;
  display_label: string;
  target_mode: "new" | "override";
  target_column?: string;
  formula: { tokens: FormulaToken[] };
  format: ICalculatedMetricFormat;
  display_order: number;
  is_active: boolean;
}

export type IColumnFormatSpec = ICalculatedMetricFormat;

export interface IReportColumnDef {
  name: string;
  label: string;
  options: {
    filter?: boolean;
    sort?: boolean;
    sortCompare?: (
      order: "asc" | "desc"
    ) => (obj1: { data: any }, obj2: { data: any }) => number;
  };
  /** Predicted-error percentage, coloured by band rather than shown as a bare number. */
  isErrorPct?: boolean;
  format?: IColumnFormatSpec;
}

export interface IValidationErrors {
  name?: string;
  description?: string;
  createdBy?: string;
  startDate?: string;
  endDate?: string;
  dimensions?: string;
  metrics?: string;
  idCampaign?: string;
}
